<template lang="pug">

    .three.fields

        address-dropdown-field(
            v-bind:address-models='addressModelOptions'
            v-bind:country-models='countryModels'
            v-bind:label='label'
            v-bind:person-models='personModels'
            v-bind:company-model='companyModel'
            v-bind:force-shipping-address='true'
            v-model='address'
        )
            field-error(attribute='address' v-bind:validation='validation')

        number-field(label='Anzahl' v-model='amount' v-bind:min='0')
            field-error(attribute='amount' v-bind:validation='validation')

        dropdown-field(
            label='Empfänger'
            optionLabel='name'
            optionValue='id'
            v-bind:options='recipientOptions'
            v-model='recipient'
        )
            field-error(attribute='recipient' v-bind:validation='validation')

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import * as AddressUtils from '@/utils/address'
    import AddressDropdownField from '@/components/addresses/DropdownField'
    import DropdownField from '@/components/form/DropdownField'
    import FieldError from '@/components/form/SmartFieldError'
    import NumberField from '@/components/form/NumberField.vue'

    export default {
        name: 'products-forms-specimen-copy-form',

        components: { AddressDropdownField, DropdownField, FieldError, NumberField },

        computed: {

            address: {
                get() { return this.value.address },
                set(value) { this.updateValue('address', value) }
            },

            addressModelOptions() {
                return R.compose(

                    // Namen von Standardlieferadresse formatieren
                    R.map(AddressUtils.format_name_by_default_shipping_address),

                    // Nach Standard-Lieferadresse sortieren
                    AddressUtils.sort_by_is_default_shipping_address

                )(this.addressModels)
            },

            amount: {
                get() { return this.value.amount },
                set(value) {
                    R.compose(

                        // Wert setzen
                        R.curryN(2, this.updateValue)('amount'),

                        // Wenn Wert kleiner-gleich 0 dann `null` setzen
                        R.when(R.lte(R.__, 0), R.always(null))

                    )(value)
                }
            },

            recipient: {
                get() { return this.value.recipient },
                set(value) { this.updateValue('recipient', value) }
            },

            recipientOptions() {
                return this.recipientPersonModels.map(person => ({
                    id: person.id,
                    name: `${person.firstName} ${person.lastName}`
                }))
            },

        },

        created() {
            // ggf. Standardadresse setzen
            if (this.enablePreselection && R.isNil(this.address)) {
                this.updateValue('address', AddressUtils.find_default_shipping_address(this.addressModels).id)
            }
        },

        methods: {

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate();
            },

        },

        props: {

            addressModels: {
                type: Array,
                required: true
            },

            companyModel: {
                type: Object,
                required: true
            },

            countryModels: {
                type: Array,
                required: true
            },

            enablePreselection: {
                type: Boolean,
                default: false
            },

            label: {
                type: String,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            },

            recipientPersonModels: {
                type: Array,
                required: true
            },

            value: {
                type: Object,
                required: true
            }
        },

        validators: {

            address(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (!R.isNil(this.amount) && R.isNil(value)) {
                        return 'Bitte Lieferadresse angeben'
                    }
                })
            },

            amount(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (!R.isNil(this.address) && R.isNil(value)) {
                        return 'Bitte Anzahl angeben'
                    }
                })
            },

            recipient(value) {
                return Validator.value(R.defaultTo('', value)).custom(() => {
                    if (!R.isNil(this.amount) && R.isNil(value)) {
                        return 'Bitte Empfänger angeben'
                    }
                })
            },

        },

    }

</script>
